import {API} from "./API";
import {Document} from "../models/Document";
import {Utility} from "../core/Utility";
import {LoggerService} from "../core/logger/LoggerService";

export class DocumentsAPI extends API<Document> {

	constructor () {
		super("documents");
    }

	public action (action: string, item: Document): Promise<any> {
		if (Utility.isNullOrUndefined(item.id)) LoggerService.addError("Id not defined");
		let url = `/${this.endpoint}/${item.id}/action/${action}`;
		let payload = item;
		return API.axiosInstance.put(url, payload);
	}

	public indexingNumber (): Promise<any> {
		let url = `/${this.endpoint}/indexing-number`;
		return API.axiosInstance.get(url);
	}
}
